import { useEffect, useState } from 'react';
import { ISubmissionStageStatusSetting, getSubmissionStageStatus } from 'wisestep-api';

import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

export const useSubmissionStageStatus = () => {
  const [submissionStageData, setSubmissionStageData] = useState<ISubmissionStageStatusSetting[]>(
    []
  );
  const setNotification = useNotificationStore((state) => state.setNotification);

  const fetchSubmissionStageStatus = async () => {
    try {
      const response = await getSubmissionStageStatus();
      if (response?.data) {
        setSubmissionStageData(response.data);
      } else {
        setSubmissionStageData([]);
      }
    } catch (error) {
      console.error('Error fetching submission stage status:', error);
      setNotification(warning('Failed to fetch submission stage status'));
    }
  };

  useEffect(() => {
    fetchSubmissionStageStatus();
  }, []);

  return { submissionStageData, fetchSubmissionStageStatus };
};
